export enum FileUploadError {
  SizeLimitExceed = 'SizeLimitExceed',
  Corrupt = 'Corrupt',
  NotSupportedType = 'NotSupportedType',
  TooManyPages = 'TooManyPages',
  TooManyFiles = 'TooManyFiles',
  OneFileOnly = 'OneFileOnly',
  TooLongFileName = 'TooLongFileName',
  Other = 'Other',
}

export enum PDFBoardStrategy {
  CurrentBoard = 'CurrentBoard',
  NewBoard = 'NewBoard',
  OneBoardPerPage = 'OneBoardPerPage',
}

export const MAX_PAGES_FOR_ONE_PAGE_BER_BOARD = 30;
export const MAX_FILE_NAME_CHARS = 200;
export const NEW_MAX_FILE_SIZE_IN_MB = 100;
export const OLD_MAX_FILE_SIZE_IN_MB = 25;
export const LARGE_FILE_THRESHOLD = 10;
export const MAX_PDF_PAGES = 70;
